import type { FaireProductEntity } from "../../entity_types/product";

export const p_2m5bvkaqpt: FaireProductEntity = {
  token: "p_2m5bvkaqpt",
  type: "product",
  name: "CeCe Knitted Alpaca Scarf",
  brandToken: "b_bdktycs6",
  brandName: "Na Nin",
  imageUrl:
    "https://cdn.faire.com/fastly/5d6b3667345c3c0f39e9bf6208904404396abb605811a45d39e9774289e7992d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e2db5b67dfe6202e20341af0dccaef823ca7b7b3ff9e070271b0e4622befa45.jpeg",
    "https://cdn.faire.com/fastly/3b24d1df8ef6359f8903edafee8fab7d2c2a974d9ed5404c307bbebc79ed66cc.jpeg",
    "https://cdn.faire.com/fastly/0ead15409a9b2475405332a055eca3f6ee3c1112c18bf5a975b8729235754066.jpeg",
    "https://cdn.faire.com/fastly/d174909c0c8bc69026fdf472310125cbd340c49e431bcdb831be4137afceec5e.jpeg",
    "https://cdn.faire.com/fastly/750a047ff3b92fd3fec60a2472d0136e671343887954a997c0b26b795593790f.jpeg",
    "https://cdn.faire.com/fastly/fa65f8ad3213bf33c427b6bbe3b5318890334534b7de96e97e228377682fa1ab.jpeg",
    "https://cdn.faire.com/fastly/474379d9de4774d6c0134b541a8220b83bced43b50d2a946ea283d1373b82240.jpeg",
    "https://cdn.faire.com/fastly/b6133d06e98621c447189db70a320a3699846d22e2a6d420dd9bdee121c6b40c.jpeg",
    "https://cdn.faire.com/fastly/b1fb8a799045e7f3b72c7e25e745d963294e247254f5d8af04e00e76650484eb.jpeg",
    "https://cdn.faire.com/fastly/98c69026805dc4abf9ee8c4c562aa4b15d549f3faa6186ae09b9755aea148609.jpeg",
    "https://cdn.faire.com/fastly/d1cc61139ff332c581bc1ffa93ba706876794be30dab2427ac829cccf289eaf6.jpeg",
    "https://cdn.faire.com/fastly/acb60056af0962550d2a50b61b375ea239fa6f6fc3326dd15617d868108b55a8.jpeg",
    "https://cdn.faire.com/fastly/cb29342b68a81491db3a54dc6d245f7c9f8e0ece952d5d2549716119dc48045e.jpeg",
    "https://cdn.faire.com/fastly/b8c063bc684f071066196492d781c2707aa0c805195d71a25a57f97d9ba9b747.jpeg",
    "https://cdn.faire.com/fastly/7dae4530fe1e5c010a9a807eb317920a2ecda3f6ea5f177fa6d92cedd0bd33b6.jpeg",
    "https://cdn.faire.com/fastly/3a2f2ebc30f67c5dd4049a511dc047e7a1d15cd0a477499ef3edaa74e5d1afb3.jpeg",
    "https://cdn.faire.com/fastly/870f2a03e4a64ff00b41eb208aeb89a05b395fe33b732be0313d4c59ff06f277.jpeg",
    "https://cdn.faire.com/fastly/9731212fc55a8be313f6132c2a31a8fd96e17193d1f0b6964eb785a3ded519a6.jpeg",
    "https://cdn.faire.com/fastly/918b9e7d0510d00bbdf2dc8d55db6b446d55b4c1af716309f060ec300ea586e3.jpeg",
    "https://cdn.faire.com/fastly/e31036bcf890142cb7149a23cd3d33474a279e33f83ad9e4ebf94f3900260649.jpeg",
    "https://cdn.faire.com/fastly/ccf11da6a966f79d146e5f223509ef248feb41eb08316c3e57a626e48649c058.jpeg",
    "https://cdn.faire.com/fastly/c316adf1e828db13bc8bb3c3b029da48c0b96f26755fde7c716036d20ee0d2e1.jpeg",
    "https://cdn.faire.com/fastly/cbdc2b23f0ff9ade8bea72a4b46448eec57ffa580684c73d52c8cbf6e2a1e7ea.jpeg",
    "https://cdn.faire.com/fastly/45bb12dfcdbb09228420e0022c42dfbfadec780612f7f88a161842db35c383a5.jpeg",
    "https://cdn.faire.com/fastly/7b26b47694eb449c34d8c006d28bb59ad505fca9e971ddbd71ad083b3df0b592.jpeg",
    "https://cdn.faire.com/fastly/40327679c77d0155e5d0789d20063e84c6a6e2c05969d96adb1e2c982f8407e3.jpeg",
    "https://cdn.faire.com/fastly/5643bda25f2e919441c31a4b59272e0b2b3ee82acbcda238ce7878025c72200d.jpeg",
    "https://cdn.faire.com/fastly/f5b20eee018ad382bea24adecb207ba2f825c6e20058e61d8ae0a46fea858c59.jpeg",
  ],
  priceDollars: 69,
  description:
    "The CeCe Scarf is an exquisite piece knit from silky, dense baby alpaca yarn. It pairs perfectly with the Frankie Hat but can be worn in a variety of ways. Versatile and timeless, the CeCe scarf will become a staple in your cool-weather wardrobe, meant to be cherished for years to come.\n\n * Ivory: Cream \n * Oat: Tan \n * Umber: Brown \n * Ash: Dark Grey\n\n * Onyx: Black \n * Stone: Heather Grey \n * Emerald: Grassy Green \n * Cobalt: Vivid Blue \n * Tomato: Firetruck Red \nMade in Peru\n\nNew color options will launch on Friday, October 10th at 12 PM. Register for restock alerts to receive updates when these become available.\n",
  tags: [],
  msrpDollars: 138,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:54.888Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
